<template>
  <div
    id="container"
    class="effect aside-float aside-bright mainnav-lg mainnav-fixed"
  >
    <common-header></common-header>
    <div class="boxed">
      <div id="content-container">
        <div id="page-content">
          <router-view></router-view>
        </div>
      </div>
      <siderbar></siderbar>
      <footer id="footer" style="padding-left: 0; z-index: 9999">
        <p class="text-center">
          &#0169; {{ new Date().getFullYear() }} 天锐峡谷
        </p>
      </footer>
      <button class="scroll-top btn">
        <i class="pci-chevron chevron-up"></i>
      </button>
    </div>
  </div>
</template>
<script>
import '@/js/bootstrap.min.js'
import '@/js/nifty.min.js'
import '@/plugins/chosen/chosen.jquery.min.js'

import CommonHeader from '@/components/Header'
import Siderbar from '@/components/Siderbar'
export default {
  components: {
    CommonHeader,
    Siderbar,
  },
}
</script>

<style>
@import '../../plugins/chosen/chosen.css';
</style>